/* eslint-disable */

export const closeContactFloating = () => {
  $(
    '#contact-floating-panel, #contact-floating-burger-icon, #contact-floating-burger, .contact-floating-button, .main-content',
  ).removeClass('is-active');
  $('.contact-floating-button').trigger('blur');
};

export const openContactFloating = () => {
  $(
    '#contact-floating-panel, #contact-floating-burger-icon, #contact-floating-burger, .contact-floating-button, .main-content',
  ).addClass('is-active');
  $('.contact-floating-button').trigger('blur');
};

export const initContactFloating = () => {
  jQuery(($) => {
    // contact_floating.js banking-theme
    $('.open-contact').on('click', function() {
      openContactFloating();
    });
  
    $('.close-contact').on('click', function() {
      closeContactFloating();
    });
  
    $('.contact-floating-button').on('keyup', function(e) {
      if (e.key === 'Enter') {
        openContactFloating();
        e.preventDefault();
      }
  
      if (e.key === 'Escape') {
        closeContactFloating;
      }
    });
  });
};
